import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const Villagers = ({ filteredVillagers, setOneVillager, setInputValue }) => (
  <ul>
    {filteredVillagers.map((villager) => (
      <li key={uuidv4()}>
        <button
          onClick={() => {
            setOneVillager(villager);
            setInputValue('');
          }}
          type="button"
        >
          {villager.name.fr}
        </button>
      </li>
    ))}
  </ul>
);

Villagers.propTypes = {
  filteredVillagers: PropTypes.arrayOf(PropTypes.object).isRequired,
  setOneVillager: PropTypes.func.isRequired,
  setInputValue: PropTypes.func.isRequired,
};

export default Villagers;
